import { Card, Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { truncateLocationName } from "../../../utils";
const BookReservationCard = (props) => {
  return (
    <Card
      style={{ cursor: "pointer" }}
      sx={{ width: 1, maxWidth: 430, borderRadius: "10px", mb: 1 }}
      onClick={props.onClick}
    >
      <Grid container direction="row" justifyContent="center">
        <Grid
          item
          xs={4}
          sx={{
            backgroundColor: "#73A6FF",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            p: 1,
          }}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Box
            style={{
              backgroundColor: "#73A6FF",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              style={{
                alignSelf: "center",
                color: "white",
                alignContent: "center",
                alignItems: "center",
              }}
              variant="fontSize14"
            >
              {props?.data?.location_city}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={8} sx={{ p: 1 }}>
          <Typography variant="fontSize12" color={"#333333"}>
            {truncateLocationName(props?.data?.location_display_name)}
          </Typography>

          <Stack alignItems="center" direction="row" spacing={0}>
            <LocationOnIcon
              fontSize="10"
              color="#908E8D"
              style={{ fill: "#908E8D" }}
            />
            <Typography variant="fontSize12" color={"#605E5C"}>
              {props?.data?.location_address_line_1}
            </Typography>
          </Stack>
        </Grid>
      </Grid>{" "}
    </Card>
  );
};

export default BookReservationCard;
